module.exports = __webpack_public_path__ + "static/media/sps_trebic_logo.c14d8604.png";